const trimMs = str => str.replace(/ms|s/, '')
export default trimMs
